import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  products: [],
  featuredProducts: [],
  newArrivals: [],
  currentProduct: null,
  loading: false,
  error: null,
  totalPages: 0,
  currentPage: 0
}

const productSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload.content || action.payload
      state.totalPages = action.payload.totalPages || 0
      state.currentPage = action.payload.number || 0
    },
    setFeaturedProducts: (state, action) => {
      state.featuredProducts = action.payload
    },
    setNewArrivals: (state, action) => {
      state.newArrivals = action.payload
    },
    setCurrentProduct: (state, action) => {
      state.currentProduct = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
})

export const { 
  setProducts, 
  setFeaturedProducts, 
  setNewArrivals, 
  setCurrentProduct, 
  setLoading, 
  setError 
} = productSlice.actions

export default productSlice.reducer